/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Active_Models_BadgeInputs */



/**
* | output |
* | --- |
* | "Distinct models used" |
*
* @param {Dashboard_Active_Models_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_active_models_badge = /** @type {((inputs?: Dashboard_Active_Models_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Active_Models_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwendete Modelle")
	return /** @type {LocalizedString} */ ("Distinct models used")
});